<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Noto Sans TC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

.bg-breadcrumb {
  background-color: #f2f2f2;
}

.bg-ptc1 {
  background-color: #004f2d !important;
}

.btn-circle {
  border-radius: 20px !important;
  cursor: pointer;
  font-size: 14px !important;
  height: 36px;
  line-height: 1.428571429 !important;
  outline: none;
  text-align: center !important;
  width: 36px;
}

.btn-circle:focus, .btn-circle.focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.btn-circle .fas.fa-pencil-alt {
  margin: 0 0 0 1px !important;
}

.btn-circle .fas.fa-key {
  margin: 0 0 0 1px !important;
}

.btn-circle .fas.fa-search {
  margin: 0 0 0 -3px !important;
}

.btn-circle .fas.fa-trash-alt {
  margin: 0 0 0 0px !important;
}

.btn-circle .fas.fa-times {
  margin: 0 0 0 1px !important;
}

.btn-circle.btn-lg {
  width: 50px;
  height: 50px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 25px;
}

.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  font-size: 24px;
  line-height: 1.33;
  border-radius: 35px;
}

.btn-circle-ptc1 {
  color: #519b39 !important;
  background-color: #fff !important;
  border: solid 1px;
  border-color: #519b39 !important;
}

.btn-circle-ptc1:hover {
  color: #fff !important;
  background-color: #519b39 !important;
  border-color: #519b39 !important;
}

.btn-clear {
  background-color: #bdbdbd !important;
  border-radius: 0 !important;
  color: #3b3b3b !important;
}

.btn-ptc1 {
  background-color: #179A53 !important;
  border-color: #fff3e5 !important;
  border-radius: 0 !important;
  color: #fff !important;
}

.btn-normal-ptc1 {
  background-color: #fff !important;
  /* border-color: #004f2d !important;
  border-style: solid !important;
  border-width: 2px !important; */
  border-radius: 0 !important;
  color: #004f2d !important;
  font-weight: bold !important;
}

.btn-preview {
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #004f2d !important;
}

.btn-publish {
  background-color: #f35050 !important;
  border-color: fb792d !important;
  border-radius: 0 !important;
  color: #fff !important;
}

.btn-save {
  background-color: #fed100 !important;
  border-radius: 0 !important;
  color: #000000 !important;
}

.button-toolbar-ptc {
  background-color: #f2f2f2 !important;
  padding-bottom: 5px;
  padding-top: 5px;
}

.card {
  margin: 30px;
}

.card:hover {
  box-shadow: 1px 1px 38px -8px #8e8c8e;
}

.card-body {
  padding: 0.75rem 1.25rem;
}

.card-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  margin-top: 0;
  padding-bottom: 0.75rem;
}

h4.card-title {
  font-size: 16px;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #519b39 !important;
  border-color: #004f2d !important;
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::after {
  background-color: #badcaf !important;
  border: 1px solid #004f2d !important;
  border-radius: 2px !important;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #519b39 !important;
  border: 0px !important;
}

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::after {
  background-color: #badcaf !important;
  border-radius: 15px !important;
}

.form-control {
  border-radius: 0 !important;
}

.form-control:focus {
  border-color: #519b39 !important;
  border-radius: 0 !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(81, 155, 57, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(81, 155, 57, 0.25);
}

.form-group .col-form-label{
  color: #f08200 !important;
  font-weight: bold;
}

#func-content {
  height: 300px;
  overflow-y: auto;
  height: calc(100vh - 160px);
}

.navbar-brand {
  margin-right: 0 !important;
  text-align: center;
  width: 250px;
}

.navbar-brand img {
  height: 32px;
}

.navbar-ptc {
  box-shadow: 0 2px 4px rgba(0,0,0,.5) !important;
  -webkit-box-shadow: 0px 2px 4px rgba(0,0,0,.5) !important;
}

#navbar-ddown.btn-group > .btn {
  background-color: transparent !important;
  border-color: transparent !important;
}

#navbar-ddown.btn-group > .btn:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.page-item.active .page-link {
  background-color: #519b39 !important;
  border-color: #519b39 !important;
  color: #FFFFFF !important;
}

.page-link {
  color: #519b39 !important;
}

.toolbar-ptc {
  background-color: #138045;
  margin: 0 !important;
  padding: 11px 0 5px 0;
  height: 64px;
}

.toolbar-ptc .title{
  color: #f2f2f2;
  padding-top: 8px;
}

.wrapper {
  display: flex;
  width: 100%;
}

.btn-primary {
  background-color: #519b39 !important;
  border-color: #519b39 !important;
}

.btn-primary:active, .btn-primary:focus, .btn-primary:hover {
  background-color: #138045 !important;
  border-color: #138045 !important;
}

.btn-info {
  color: #000000 !important;
  background-color: #c4e1b2 !important;
  border-color: #c4e1b2 !important;
}

.btn-info:active, .btn-info:focus, .btn-info:hover {
  color: #000000 !important;
  background-color: #c4e1b2 !important;
  border-color: #c4e1b2 !important;
  box-shadow: 0 0 0 rgba(0,0,0,.5) !important;
}

.nav-link {
  color: #004f2d;
}
.nav-link:hover {
  color: #179a53;
}
.btn-warning {
  background-color: #179a53 !important;
  border-color: #179a53 !important;
}
.btn-warning:hover {
  background-color: #138045 !important;
  border-color: #FFFFFF !important;
}
.btn-warning:focus {
  border-color: #179a53 !important;
  box-shadow: #179a53 !important;
  -webkit-box-shadow: 0px 0px 0px 3px rgba(23,154,83,.5) !important;
}

.btn-outline-primary {
  color: #916b58 !important;
  border-color: #916b58 !important;
}
.btn-outline-primary:hover {
  background-color: #916b58 !important;
  border-color: #FFFFFF !important;
  color: #FFFFFF !important;
}

.btn-outline-primary:active {
  background-color: #916b58 !important;
  box-shadow: 0 0 0 rgba(0,0,0,.5) !important;
  color: #FFFFFF !important;
  background-color: #916b58 !important;
  border-color: #916b58 !important;
  -webkit-box-shadow: 0px 0px 0px 3px rgba(145,107,88,.5) !important;
}

.btn-outline-primary:focus {
  border-color: #916b58 !important;
  box-shadow: 0 0 0 rgba(0,0,0,.5) !important;
  -webkit-box-shadow: 0px 0px 0px 3px rgba(145,107,88,.5) !important;
}

.btn-outline-light {
  color: #179a53 !important;
  border-color: #179a53 !important;
}
.btn-outline-light:hover {
  background-color: #179a53 !important;
  border-color: #FFFFFF !important;
  color: #000000 !important;
}

.btn-outline-light:active {
  background-color: #179a53 !important;
  box-shadow: 0 0 0 rgba(0,0,0,.5) !important;
  color: #FFFFFF !important;
  background-color: #179a53 !important;
  border-color: #179a53 !important;
  -webkit-box-shadow: 0px 0px 0px 3px rgba(23,154,83,.5) !important;
}

.btn-outline-light:focus {
  border-color: #179a53 !important;
  box-shadow: 0 0 0 rgba(0,0,0,.5) !important;
  -webkit-box-shadow: 0px 0px 0px 3px rgba(23,154,83,.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue